
function Card (props) {
    const { name, materialsCount, partnersCount } = props
   
    const renderDetails = (title,total) =>{
            return <><div className='cardBoxWrapper'>
                <div className='cardBoxWrap'>
                    <h3>{total}</h3>
                </div>
                <h4>{title}</h4>
            </div></>
    }

    return materialsCount > 0 || partnersCount >0 ? <div className='' >
        <div className="cardBox px-3" >
            <div> 
            <h1>{name}</h1>
            <h2>chain has</h2>
            </div>
            <div className='cardBoxDetail'>
                {renderDetails(materialsCount === 1 ? "MATERIAL": "MATERIALS",materialsCount)}
                {renderDetails(partnersCount === 1 ? "PARTNER":"PARTNERS",partnersCount)}
            </div>
        </div>
    </div>:null
}

export default Card